/**
 * The Sentry hooks main.js installs: every scrub that must run on a captured
 * event or breadcrumb, composed in one place so a new one cannot be added to
 * one hook and forgotten on the other.
 *
 *  - the storefront resume code in a URL fragment (redactResumeCode.js);
 *  - Net Checkout PIN request bodies (redactNetPinRequest.js).
 */
import { sentryBeforeSend, sentryBeforeBreadcrumb } from "@/utils/redactResumeCode";
import { scrubNetPinRequest } from "@/utils/redactNetPinRequest";

export function beforeSend(event) {
  return scrubNetPinRequest(sentryBeforeSend(event));
}

export function beforeBreadcrumb(breadcrumb) {
  return scrubNetPinRequest(sentryBeforeBreadcrumb(breadcrumb));
}
